import * as React from "react"
const THEMEURL = window.drupalSettings ? `/${window.drupalSettings.path.themeUrl}` : '/themes/custom/mx_aguas_firmes_theme';

export default ({ delay }: any) => {
    return (
        <img className="scroll-animation" src={`${THEMEURL}/sources/dist/assets/images/icons/mouse-scroll.gif`} alt="" title="" data-aos='fade-in' data-aos-delay={delay} />
    )
}